import axiosClient from "./axiosClient";
import { IListProductsParams } from "./categories";

export const vehicleApi = {
    getVehicle: (params: IListProductsParams) => {
        const url = `api/search-vehicle/?categoryId=${params.category}&name=${params.name}`;
        return axiosClient.get(url);
    },
    getVehicleList: (params: {id:number, category:number}) => {
        const url = `/api/vehicle-item/${params.id}/?category=${params.category}`;
        return axiosClient.get(url);
    },
    getVehicleDetail: (params: {id:number}) => {
        const url = `/api/vehicleItem-detail/${params.id}`;
        return axiosClient.get(url);
    },
    getVehicleCalendar: (params:any)=>{
        const url = `/api/vehicleItem-history/${params.id}?onlyActive=${params.onlyActive}`;
        return axiosClient.get(url);
    },
    borrowVehicle: (params:any,id:any) =>{
        const url = `/api/borrowing-vehicleItem/${id}`;
        return axiosClient.post(url,params);
    },
    vehicleRecurring: (params:any,id:any) =>{
        const url = `/api/vehicleItem-recurring/${id}`;
        return axiosClient.post(url,params);
    },
    vehicleModify: (params:any,id:any) =>{
        const url = `/api/vehicleItem-modification/${id}`;
        return axiosClient.post(url,params);
    },




    getVehicleBorrowingHistory: (params: any) => {
        const url = `/api/vehicleItem-history/${params.id}/${params.itemId}`;
        return axiosClient.get(url);
    },
    getVehicleBorrowingList: (params: {
      year: number,
      month: number,
      category_id?: number;
      subCategory_id?:number;
      searchWord?: string;
    }) => {
        // const url = `/api/vehicle-borrowing?year=${params.year}&month=${params.month}`;
        const searchParams = new URLSearchParams({
          year: params.year.toString(),
          month: params.month.toString(),
      });

      if (params.category_id !== undefined) {
          searchParams.append('category_id', params.category_id.toString());
      }

      if (params.subCategory_id !== undefined) {
          searchParams.append('subCategory_id', params.subCategory_id.toString());
      }

      if (params.searchWord !== undefined) {
          searchParams.append('searchWord', params.searchWord.toString());
      }

      const url = `/api/vehicle-borrowing?onlyActive=false&${searchParams.toString()}`;

      return axiosClient.get(url);
    }
};
